import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/operations`)
  return data.data
}

export const useOperations = () => {
  const { data, ...props } = useQuery(
    queryKeys.OPERATIONS,
    () => getData(),
  )
  return { data, ...props }
}
